import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../utilities';

const initialState = {
    adminItems:[],
    adminItemsLoading: false,
    selectedAdmin:"country",
    selectedAdminItem:null,
    selectedAdminLabel:"Επικράτεια",
    selectedStatsType:"fires",
    statsFires:{
        results:{
            xTitle:"", 
            xKey:"", 
            yTitle:"", 
            data:[]
        }, 
        numbers:{
            xTitle:"", 
            xKey:"",
            yTitle:"", 
            data:[]
        }
    },
    statsClc:{
        results:{
            xTitle:"", 
            xKey:"", 
            yTitle:"", 
            data:[]
        }
    },
    statsClcAll:null,
    statsClcYears:null,
    statsClcLastYear:null
}

const getAdminWithFiresStarted = (state) => {
    return updateObject(state, {adminItems:[], adminItemsLoading:true});
}

const getAdminWithFiresSuccess = (state,action) => {
    let adminItems = [];

    action.admin.features.forEach(adminItem => {
        adminItems.push({value: adminItem.properties.code, label:adminItem.properties.name})
    });

    return updateObject(state, {adminItems:adminItems, adminItemsLoading:false});
}

const getStatisticsSuccess = (state,action) => {
    let xTitle = "Έτος";
    let yTitle = "Έκταση (εκτάρια)";
    let xKey = "year";
    let statsType = "statsFires";
    let statsClcAll = {};
    let stats = null;
    let statsClcLastYear = 0;
    let statsClcYears = [];
    let clcLabels = {
        "ahaclc1":"Τεχνητές επιφάνειες (CLC2018, Κωδικός: 1)",
        "ahaclc2":"Γεωργικές περιοχές (CLC2018, Κωδικός: 2)",
        "ahaclc311":"∆άσος πλατύφυλλων (CLC2018, Κωδικός: 311)",
        "ahaclc312":"∆άσος κωνοφόρων (CLC2018, Κωδικός: 312)",
        "ahaclc313":"Μικτό δάσος (CLC2018, Κωδικός: 313)",
        "ahaclc321":"Φυσικοί βοσκότοποι (CLC2018, Κωδικός: 321)",
        "ahaclc322":"Θάµνοι και χερσότοποι (CLC2018, Κωδικός: 322)",
        "ahaclc323":"Σκληροφυλλική βλάστηση (CLC2018, Κωδικός: 323)",
        "ahaclc324":"Μεταβατικές δασώδεις και θαµνώδεις εκτάσεις (CLC2018, Κωδικός: 324)",
        "ahaclc33":"Ανοιχτοί χώροι µε λίγη ή καθόλου βλάστηση (CLC2018, Κωδικός: 33)",
        "ahaclc4":"Υγρότοποι (CLC2018, Κωδικός: 4)",
        "ahaclc5":"Υδάτινες επιφάνειες (CLC2018, Κωδικός: 5)"
    }

    if (action.selectedStatsType === "clc"){
        // TODO: change the above variables
        statsType = "statsClc";
        xTitle = "Corine land cover";
        xKey = "clc";

        stats = {
            results:{
                xTitle:xTitle, 
                xKey:xKey, 
                yTitle:yTitle, 
                data:[]
            }
        };

        // Get the keys
        const keys = Object.keys(action.stats.features[0].properties);

        // A variable with data for all years
        action.stats.features.forEach(stat => {
            statsClcAll[stat.properties.year] = [];
            statsClcYears.push({value:stat.properties.year, label:stat.properties.year});
            
            keys.forEach(key => {
                if (key !== "year"){
                    statsClcAll[stat.properties.year].push({clc:clcLabels[key], value:parseFloat(stat.properties[key].toFixed(2))});
                }
            });
            statsClcLastYear = stat.properties.year;
        });   

        stats.results.data = [...statsClcAll[statsClcLastYear]]

    } else {
        stats = {
            results:{
                xTitle:xTitle, 
                xKey:xKey, 
                yTitle:yTitle, 
                data:[]
            }, 
            numbers:{
                xTitle:xTitle, 
                xKey:xKey,
                yTitle:"Αριθμός πυρκαγιών", 
                data:[]
            }
        };
    
        action.stats.features.forEach(stat => {
            stats.results.data.push({[xKey]:stat.properties[xKey], value:parseFloat(stat.properties.value.toFixed(2))});
            stats.numbers.data.push({[xKey]:stat.properties[xKey], value:parseInt(stat.properties.count)})
        }); 
    }
    
    return updateObject(state, {[statsType]:stats, statsClcAll:statsClcAll, statsClcYears:statsClcYears, statsClcLastYear:statsClcLastYear});
}

const updateSimpleVariable = (state,action) => {
    return updateObject(state, {[action.variableName]:action.newValue});
}

const changeClcYear = (state,action) => {
    let statsClc = {...state.statsClc};
    statsClc.results.data = state.statsClcAll[action.year];
    
    return updateObject(state, {statsClc:statsClc});
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.GET_ADMIN_WITH_FIRES_STARTED: return getAdminWithFiresStarted(state);
        case actionTypes.GET_ADMIN_WITH_FIRES_SUCCESS: return getAdminWithFiresSuccess(state,action);
        case actionTypes.GET_STATISTICS_SUCCESS: return getStatisticsSuccess(state,action);
        case actionTypes.UPDATE_SIMPLE_VARIABLE: return updateSimpleVariable(state,action);
        case actionTypes.CHANGE_CLC_YEAR: return changeClcYear(state,action);
        default: return state;
    }
};

export default reducer;